import type { Toast } from 'components/notifications-fi/toast-notification-fi/ToastNotificationFi.vue';
import { useDict } from 'composables/fischerPlugin';
import { defineStore } from 'pinia';
// @ts-ignore
import { useStore } from 'vuex';

export const useNotificationStore = defineStore('useNotificationStore', {
  state() {
    const store = useStore();
    const dict = useDict();

    const openToastNotification = (notification: Toast) =>
      store.dispatch('notifications/openToastNotification', notification);

    const openGeneralErrorNotification = () =>
      store.dispatch('notifications/openGeneralErrorNotification', { dict });

    return { openToastNotification, openGeneralErrorNotification };
  },
});
